<template>
  <div id="Pardakht" dir="rtl">
    <card back>
      <template v-slot:header>
        <h4 class="d-inline">فرم پرداخت</h4>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="row">
              <div class="col-md-6 col-12 text-right">
                <small>شماره حساب</small>
                <div class="input-group">
                  <input
                    ref="txtVCode"
                    @focusout="ComplateVcode($event)"
                    v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                    :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                    type="text"
                    @keypress="$ValidNumber($event, 16)"
                    @keydown="SearchVcode($event)"
                    class="form-control InputText"
                    style="direction: ltr"
                    id="txtVCode"
                    v-model="txtVCode"
                    tabindex="1"
                  />
                  <div class="input-group-prepend">
                    <button type="button" @click="btnSearchVcode()" tabindex="-1" id="button-addon2" class="btn btn-outline-danger" data-toggle="modal" data-target="#Modal-light" dir="ltr">
                      <span class="fa fa-list" tabindex="-1"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <small>تاریخ سند</small>
                <date-picker :editable="true" color="rgb(220 53 69)" v-model="DataAxios_Pardakht.ArryfildValue.TarixSanad"></date-picker>
                <input type="text" tabindex="-1" class="d-none InputText" style="direction: ltr" />
              </div>
            </div>
            <div v-if="LoadItem" class="row border Rounded p-1 m-1">
              <div class="col-md-8 col-12">
                <i class="fas fa-user text-danger"></i>
                <span v-if="LoadItem" class="text-secondary font-weight-normal p-1 mt-1">{{ lblMoshaxasat }}</span>
              </div>
              <div class="col-md-4 col-12">
                <ul class="list-inline pr-0 m-0">
                  <li class="list-inline-item text-secondary">شناسه :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtShenase }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="LoadItem && TblSarfaslTypeId != 1" class="row">
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">موجودی :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtMandeBefore }}
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0">
                  <li class="list-inline-item text-secondary">مبلغ مسدود :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtMasdood }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- مانده تسهیلات -->
            <div v-if="LoadItem && TblSarfaslTypeId == 1" class="row mt-2 mb-2 p-2 mr-2 ml-2">
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">مانده بدهی :</li>
                  <li class="list-inline-item float-left text-danger" style="font-size: 17px !important">
                    {{ txtMandeBefore }}
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0">
                  <li class="list-inline-item text-secondary">مانده جدید :</li>
                  <li class="list-inline-item float-left" style="font-size: 17px !important">
                    {{ txtMasdood }}
                  </li>
                </ul>
              </div>
            </div>
            <!-- مانده تسهیلات -->
            <div v-if="LoadItem && TblSarfaslTypeId != 1" class="row">
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">قابل برداشت :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtGhabeleBardasht }}
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0">
                  <li class="list-inline-item text-secondary">مانده جدید :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtMandeAfter }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="LoadItem && TblSarfaslTypeId != 1" class="row">
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-danger">معوقه خود :</li>
                  <li class="list-inline-item text-danger float-left bnp-lblFont">
                    {{ txtMoavaghe }}
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0">
                  <li class="list-inline-item text-danger">معوقه مضنونین :</li>
                  <li class="list-inline-item text-danger float-left bnp-lblFont">
                    {{ txtMoavagheMazmonin }}
                  </li>
                </ul>
              </div>
            </div>
            <div v-if="LoadItem" class="row">
              <div class="col-md-9 col-12">
                <small> مـبــلـغ پرداخت : </small><small class="text-muted">{{ Mab2persian }}</small>
                <input
                  ref="txtMab"
                  type="text"
                  dir="ltr"
                  @keydown="$DotInMablagh($event, 13)"
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMab = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOutMab($event)"
                  class="form-control InputText 3ragham text-danger bnpFont"
                  id="txtMab"
                  v-model="txtMab"
                  tabindex="2"
                />
              </div>
              <div class="col-md-3 col-12">
                <small>فیش : </small>
                <input type="text" dir="ltr" @keypress="$ValidNumber($event, 10, true)" class="form-control" id="txtFish" v-model="txtFish" tabindex="3" />
              </div>
            </div>
            <div v-if="LoadItem" class="row">
              <div class="col-md-3 col-12">
                <small>برداشت کننده : </small>
                <input type="text" dir="rtl" @keypress="$ValidPersian($event, 40)" class="form-control" id="txtVarizkonande" v-model="txtVarizkonande" tabindex="4" />
              </div>
              <div class="col-md-9 col-12">
                <small>شرح : </small>
                <div class="input-group mb-2">
                  <input type="text" dir="rtl" @keypress="$ValidPersian($event, 100)" class="form-control" id="txtDes" tabindex="5" aria-label="Example text with button addon" aria-describedby="button-addon1" v-model="txtDes" />
                  <!-- <div class="input-group-prepend">
                    <button
                      class="btn btn-outline-danger"
                      type="button"
                      id="button-addon1"
                      @click="BtntxtDes()"
                      data-toggle="modal"
                      data-target="#ModalBanafash"
                      tabindex="-1"
                    >
                      <span class="fa fa-list" tabindex="-1"></span>
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
            <div v-if="LoadItem" class="row">
              <div class="col-md-3">
                <div class="form-group row">
                  <small class="col-md-6 col-12 pl-0 col-form-label">روش : </small>
                  <div class="col-md-6 col-12">
                    <input type="number" maxlength="1" @keyup="txtRaveshFocusOut($event)" @focus="txtRaveshFocus($event)" @focusout="txtRaveshFocusOut($event)" class="form-control text-center bnpFont" id="txtRavesh" v-model="txtRavesh" tabindex="6" />
                  </div>
                </div>
              </div>
              <div class="col-md-9 col-12">
                <div class="btn-group btn-group-toggle w-100" data-toggle="buttons" tabindex="-1">
                  <label tabindex="-1" class="btn btn-dark" :class="txtRavesh == 1 ? 'active focus' : ''">
                    <input tabindex="-1" @click="txtRavesh = 1" type="radio" name="options" id="rdiNaghdi" :checked="txtRavesh == 1 ? true : false" />
                    نقدی
                  </label>
                  <label tabindex="-1" class="btn btn-dark" :class="txtRavesh == 2 ? 'active focus' : ''">
                    <input tabindex="-1" @click="txtRavesh = 2" type="radio" name="options" id="rdiBanki" :checked="txtRavesh == 2 ? true : false" />
                    بانکی
                  </label>
                  <label tabindex="-1" class="btn btn-dark" :class="txtRavesh == 3 ? 'active focus' : ''">
                    <input tabindex="-1" @click="txtRavesh = 3" type="radio" name="options" id="rdiTarkibi" :checked="txtRavesh == 3 ? true : false" />
                    ترکیبی
                  </label>
                  <label tabindex="-1" class="btn btn-dark" :class="txtRavesh == 4 ? 'active focus' : ''">
                    <input tabindex="-1" @click="txtRavesh = 4" type="radio" name="options" id="rdiAzHesab" :checked="txtRavesh == 4 ? true : false" />
                    حسابی
                  </label>
                  <!-- <label
                    tabindex="-1"
                    class="btn btn-dark"
                    :class="txtRavesh == 5 ? 'active focus' : ''"
                  >
                    <input
                      tabindex="-1"
                      @click="txtRavesh = 5"
                      type="radio"
                      name="options"
                      id="rdiHavaleCheck"
                      :checked="txtRavesh == 5 ? true : false"
                    />
                    حواله/چک
                  </label> -->
                </div>
              </div>
            </div>
            <!-- روش بانکی -->
            <div v-if="rdiBanki" class="row">
              <div class="col-md-4 col-12">
                <small id="LblTblSarfaslIdBankTarafHesab">طرف حساب :</small>

                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="getbankId" :rownumintable="3" :action="'TblCombo/GetSarfaslBySarfaslTypeId'" :method="'POST'" :idinput="'SarfaslTypeId'" :keyItem="'SarfaslTypeId'" :queryString="{ id: 4 }"> </SearchableCombo>
              </div>
              <div class="col-md-2 col-12">
                <small id="lblChandGane">چندگانه</small>
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input InputText" id="chkChandGane" tabindex="8" v-model="chkChandGane" />
                  <label class="custom-control-label" for="chkChandGane"></label>
                </div>
              </div>
              <div v-if="IsChandGane" class="col-md-6 col-12">
                <small>مبلغ این مرحله : </small>
                <input
                  type="text"
                  :disabled="rows.length > 1 && DiffMab == 0"
                  dir="ltr"
                  @keydown="
                    $DotInMablagh($event, 13)
                    InsertMab($event)
                  "
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabTaraf = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOut($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabTaraf"
                  v-model="txtMabTaraf"
                  tabindex="9"
                />
              </div>
              <div class="col-md-4 col-12">
                <small>رهگیری کارتخوان : </small>
                <input type="text" dir="ltr" @keypress="$ValidNumber($event, 10, true)" class="form-control" id="txtFishNoPos" v-model="txtFishNoPos" tabindex="10" />
              </div>
            </div>
            <!-- روش بانکی -->

            <!-- روش ترکیبی -->
            <div v-if="rdiTarkibi" class="row">
              <div class="col-md-6 col-12">
                <small id="LblTblSarfaslIdBankTarafHesab">طرف حساب :</small>
                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="getbankIdTarkibi" :rownumintable="3" :action="'TblCombo/GetSarfaslBySarfaslTypeId'" :method="'POST'" :idinput="'SarfaslTypeId2'" :keyItem="'SarfaslTypeId2'" :queryString="{ id: 4 }"> </SearchableCombo>
              </div>
              <div class="col-md-6 col-12">
                <small id="lblChandGane">چندگانه</small>
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input InputText" id="chkChandGaneTarkibi" tabindex="8" v-model="chkChandGaneTarkibi" />
                  <label class="custom-control-label" for="chkChandGaneTarkibi"></label>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <small v-if="!IsChandGaneTarkibi">مبلغ انتقال : </small>
                <small v-if="IsChandGaneTarkibi">مبلغ این مرحله : </small>
                <input
                  :disabled="rows.length > 1 && DiffMab == 0"
                  v-if="!IsChandGaneTarkibi"
                  type="text"
                  dir="ltr"
                  @keydown="$DotInMablagh($event, 13)"
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabBankTarkibi = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOut($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabBankTarkibi"
                  v-model="txtMabBankTarkibi"
                  tabindex="9"
                />
                <input
                  v-if="IsChandGaneTarkibi"
                  type="text"
                  dir="ltr"
                  @keydown="
                    $DotInMablagh($event, 13)
                    InsertMabTarkibiChandGane($event)
                  "
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabBankTarkibiChandGane = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOut($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabBankTarkibiChandGane"
                  v-model="txtMabBankTarkibiChandGane"
                  tabindex="9"
                />
              </div>
              <div class="col-md-4 col-12">
                <small>مبلغ نقدی: </small>
                <input
                  type="text"
                  dir="ltr"
                  @keydown="$DotInMablagh($event, 13)"
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabTarafTarkibi = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOutTarkibi($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabTarafTarkibi"
                  v-model="txtMabTarafTarkibi"
                  tabindex="10"
                />
              </div>
              <div class="col-md-4 col-12">
                <small>رهگیری کارتخوان : </small>
                <input type="text" dir="ltr" @keypress="$ValidNumber($event, 10, true)" class="form-control" id="txtFishNoPos" v-model="txtFishNoPos" tabindex="11" />
              </div>
            </div>
            <!-- روش ترکیبی -->

            <!-- روش حسابی -->
            <div v-if="rdiAzHesab && TblSarfaslTypeId != 1" class="row">
              <div class="col-md-6 col-12 text-right">
                <small>طرف حساب</small>
                <div class="input-group">
                  <input
                    ref="txtvCodeTaraf"
                    @focusout="ComplatevCodeTaraf($event)"
                    v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'"
                    :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'"
                    type="text"
                    @keypress="$ValidNumber($event, 16)"
                    @keydown="SearchVcodeTaraf($event)"
                    class="form-control InputText"
                    style="direction: ltr"
                    id="txtvCodeTaraf"
                    v-model="txtvCodeTaraf"
                    tabindex="12"
                  />
                  <div class="input-group-prepend">
                    <button type="button" tabindex="-1" id="button-addon3" class="btn btn-outline-danger" @click="btnSearchVcodeTaraf()" dir="ltr">
                      <span class="fa fa-list" tabindex="-1"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-12">
                <small>مبلغ انتقال: </small>
                <input
                  type="text"
                  dir="ltr"
                  @keydown="$DotInMablagh($event, 13)"
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabTarafrdiAzHesab = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOut($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabTarafrdiAzHesab"
                  v-model="txtMabTarafrdiAzHesab"
                  tabindex="13"
                />
              </div>
              <!-- <div class="col-md-4 col-12">
                <small id="LblTblSarfaslIdBankTarafHesab">طرف حساب :</small>
                  <SearchableCombo
                :edit="false"
                :grp="0"
                :code="null"
                @ResultCombo="getbankIdTaraf"
                :rownumintable="3"
                :action="'TblCombo/GetSarfaslBySarfaslTypeId'"
                :method="'POST'"
                :idinput="'GetSarfaslBySarfaslTypeId'"
                :keyItem="'GetSarfaslBySarfaslTypeId'"
                :queryString="{ id: 4 }" 
              >
              </SearchableCombo>
              </div>
              <div class="col-md-4 col-12">
                <small>مبلغ بانکی: </small>
                <input
                  type="text"
                  dir="ltr"
                  @keydown="$DotInMablagh($event, 13)"
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabBankTaraf = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOut($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabBankTaraf"
                  v-model="txtMabBankTaraf"
                  tabindex="14"
                />
              </div>
              <div class="col-md-4 col-12">
                <small v-if="!IsChandGane">مبلغ نقدی :</small>
                <input
                  type="text"
                  dir="ltr"
                  @keydown="$DotInMablagh($event, 13)"
                  @keypress="$ValidNumber($event, 15, true)"
                  @keyup="txtMabNaghdiTaraf = $PutCommatoInput_New($event)"
                  @focus="Focus($event)"
                  @focusout="FocusOut($event)"
                  class="form-control InputText 3ragham"
                  id="txtMabNaghdiTaraf"
                  v-model="txtMabNaghdiTaraf"
                  tabindex="15"
                />
              </div>
              <div class="col-md-3 col-12 text-right">
                <small>شماره برگه :</small>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control InputText"
                    @keypress="$ValidNumber($event, 10, true)"
                    id="txtSeriTaraf"
                    v-model="txtSeriTaraf"
                    tabindex="16"
                  />
                  <div class="input-group-prepend">
                    <button
                      type="button"
                      tabindex="-1"
                      id="button-addon4"
                      class="btn btn-outline-danger"
                      dir="ltr"
                    >
                      <span class="fa fa-list" tabindex="-1"></span>
                    </button>
                  </div>
                </div>
              </div> -->
              <div class="col-md-3 col-12">
                <small>حواله :</small>
                <input type="text" dir="ltr" @keypress="$ValidNumber($event, 10, true)" class="form-control" id="txtFishNoPos" tabindex="17" />
              </div>
            </div>
            <!-- روش حسابی -->

            <!-- روش حواله/چک -->
            <div v-if="rdiHavaleCheck" class="row"></div>
            <!-- روش حواله/چک -->

            <!--فیلد های عمومی -->
            <div v-if="PublicFilde" class="row">
              <div class="col-md-9 col-12">
                <small>شرح حساب : </small>
                <div class="input-group mb-2">
                  <input type="text" dir="rtl" @keypress="$ValidPersian($event, 100)" class="form-control" id="txtDesBank" v-model="txtDesBank" tabindex="11" aria-describedby="button-addon2" />
                  <!-- <div class="input-group-prepend">
                    <button
                      class="btn btn-outline-danger"
                      type="button"
                      id="button-addon2"
                      tabindex="-1"
                    >
                      <span class="fa fa-list" tabindex="-1"></span>
                    </button>
                  </div> -->
                </div>
              </div>
            </div>
            <div v-if="PublicFilde || rdiNaghdi" class="row">
              <div class="col-md-12 col-12">
                <hr />
                <button class="btn btn-outline-danger m-2" type="button" @click="btnSabt()" tabindex="20">ثبت سند F6</button>
                <button class="btn btn-outline-orange m-2" type="button" tabindex="20" @click="ShowPerferaj()">ثبت سند و پرفراژ F12</button>
                <button id="btnShowModalPer" class="d-none" data-toggle="modal" data-target="#Modal-Info"></button>
              </div>
            </div>
          </div>
          <!--فیلد های عمومی -->

          <!--اطلاعات و مشخصات عضو -->

          <!-- نمونه امضا و تصویر مشتری -->
          <div class="col-md-6 col-12 border-right">
            <div v-if="LoadItem" class="row mt-4 pr-2">
              <!-- <div
                class="dropdown d-none d-sm-block"
                style="left: 5px; bottom: 10px"
              >
                <button
                  class="btn btn-dark bg-transprent"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i
                    class="fas fa-list ml-1"
                    style="font-size: 15px !important"
                  ></i>
                  اطلاعات
                </button>
                <div
                  class="dropdown-menu  Shadow-DropDown border text-right"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a
                    href="javascript:;"
                    class="dropdown-item"
                    @click="GetAzaInfo(TblAzaId, true)"
                  >
                    <i class="fas fa-user-alt ml-2"></i>
                    <span class=""> اطلاعات مشتری </span>
                  </a>
                  <a
                    href="javascript:;"
                    class="dropdown-item"
                    @click="GetAzaInfo(TblAzaId, false, 'AzaPasAndJari')"
                  >
                    <i class="fas fa-wallet ml-2"></i>
                    <span class=""> حساب ها </span>
                  </a>
                  <router-link
                    class="dropdown-item"
                    :to="{ name: 'AzaTashilats' }"
                  >
                    <i class="fas fa-handshake ml-2"></i>
                    <span class=""> تسهیلات </span>
                  </router-link>
                  <router-link
                    class="dropdown-item"
                    :to="{
                      name: 'AzaHesabHa',
                      params: { TblAzaId: TblAzaId },
                    }"
                  >
                    <i class="fas fa-credit-card ml-2"></i>
                    <span class=""> حســـاب های بانکی </span>
                  </router-link>
                  <a href="javascript:;" class="dropdown-item">
                    <i class="fas fa-comment-alt ml-2"></i>
                    <span class=""> پیامک ها </span>
                  </a>
                </div>
              </div> -->
              <b-dropdown size="md" variant="link" class="d-inline text-danger text-center" toggle-class="text-decoration-none " no-caret>
                <template #button-content
                  ><h4><i class="fad fa-stream text-secondary"></i></h4
                ></template>
                <b-dropdown-item href="#" @click="GetAzaInfo(TblAzaId, true, '')" class="text-center">اطلاعات مشتری </b-dropdown-item>
                <b-dropdown-item href="#" @click="GetAzaInfo(TblAzaId, false, 'AzaPasAndJari')" class="text-center">حساب ها </b-dropdown-item>
                <b-dropdown-item href="#" @click="GetAzaInfo(TblAzaId, false, 'AzaTashilats')" class="text-center"> تسهیلات </b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-if="LoadItem && TblSarfaslTypeId != 1" class="row mb-5">
              <div class="col-md-4 col-12"></div>
              <div class="col-md-4 col-12">
                <div class="profile_pic1">
                  <img v-if="tempSignature" :src="tempSignature" @click="showimage($event)" alt="..." class="img-circle profile_img1" @change="console.error('change', src)" id="Signature_img" />
                  <img v-else src="/img/pic/signature-logo_2.jpg" alt="..." class="img-circle profile_img1" id="Signature_img" />
                </div>
              </div>
              <div class="col-md-4 col-12">
                <div class="profile_pic1">
                  <img v-if="tempPic" @click="showimage($event)" :src="tempPic" alt="..." class="img-circle profile_img1" @change="console.error('change', src)" id="profile_img" />
                  <img v-else src="/img/pic/MoshtariPic.jpg" alt="..." class="img-circle profile_img1" @change="console.error('change', src)" id="profile_img" />
                </div>
              </div>
            </div>
            <!-- نمونه امضا و تصویر مشتری -->

            <!-- نمایش جزئیات تسهیلات -->
            <div v-if="LoadItem && TblSarfaslTypeId == 1" class="row border Rounded p-2 m-1">
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item">
                    <small> مبلغ تسهیلات : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ txtMabTashilat }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item"><small> قرارداد : </small></li>
                  <li class="list-inline-item float-left"><small>--</small></li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item">
                    <small> سر رسید قسط : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ txtSarResidGhest }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item"><small> مبلغ قسط : </small></li>
                  <li class="list-inline-item float-left">
                    <small>{{ txtMabGhest }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item">
                    <small> تعداد اقساط : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ txtTedadGhestVam }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item">
                    <small> تعداد الباقی اقساط : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ txtTedadAlbaghi }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item">
                    <small class="text-danger"> ت قسط معوقه : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small class="text-danger">{{ txtTedadGhestMoavaghe }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item text-danger">
                    <small class="text-danger"> مبلغ معوقه : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small class="text-danger">{{ txtMablaghMoavaghe }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-danger">
                    <small> تعداد اقساط پرداخت شده : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ TedadAghsatPardaxtShode }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item text-danger">
                    <small> تعداد اقساط باقیمانده : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ TedadAghsatPardaxtNaShode }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item text-danger">
                    <small> جمع زودکرد پرداخت : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small>{{ txtSumZodPar }}</small>
                  </li>
                </ul>
              </div>
              <div class="col-md-6 col-lg-5 col-12">
                <ul class="list-inline pr-0 border-secondary pl-2">
                  <li class="list-inline-item text-danger">
                    <small class="text-danger"> جمع دیرکرد پرداخت : </small>
                  </li>
                  <li class="list-inline-item float-left">
                    <small class="text-danger">{{ txtSumDirPar }}</small>
                  </li>
                </ul>
              </div>
            </div>
            <!-- نمایش جزئیات تسهیلات -->

            <!-- اطلاعات مشتری طرف -->
            <div v-if="LoadItem && LoadItemTaraf" class="row border border-right-danger Rounded p-1 m-1">
              <div class="col-md-12 col-12 mb-1">
                <p class="m-0">اطلاعات مشتری طرف</p>
                <div class="col-md-8 col-12">
                  <i class="fas fa-user text-danger"></i>
                  <span v-if="LoadItem" class="text-secondary font-weight-normal p-1 mt-1">{{ lblMoshaxasatTaraf }}</span>
                </div>
                <hr />
              </div>
              <div class="col-md-6 col-12">
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">موجودی :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtTarafMojodiAvalie }}
                  </li>
                </ul>
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">مبلغ مسدود :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtTarafMasdood }}
                  </li>
                </ul>
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">قابل برداشت :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtTarafGHabelBardasht }}
                  </li>
                </ul>
                <ul class="list-inline pr-0 border-left border-secondary pl-2">
                  <li class="list-inline-item text-secondary">مانده جدید :</li>
                  <li class="list-inline-item float-left bnp-lblFont">
                    {{ txtTarafMandeJadid }}
                  </li>
                </ul>
              </div>
              <div class="col-md-3 col-12">
                <div class="profile_pic2">
                  <img v-if="tempSignatureTaraf" :src="tempSignatureTaraf" @click="showimage($event)" alt="..." class="img-circle profile_img1" @change="console.error('change', src)" id="Signature_img2" />
                  <img v-else src="/img/pic/signature-logo_2.jpg" alt="..." class="img-circle profile_img1" id="Signature_img" />
                </div>
              </div>
              <div class="col-md-3 col-12">
                <div class="profile_pic2">
                  <img v-if="tempPicTaraf" @click="showimage($event)" :src="tempPicTaraf" alt="..." class="img-circle profile_img1" @change="console.error('change', src)" id="profile_img2" />
                  <img v-else src="/img/pic/MoshtariPic.jpg" alt="..." class="img-circle profile_img1" @change="console.error('change', src)" id="profile_img2" />
                </div>
              </div>
            </div>
            <!-- اطلاعات مشتری طرف -->

            <!-- اطلاعات سرفصل -->
            <div v-if="LoadItem && !rdiAzHesab" class="row border border-right-danger Rounded p-1 m-1">
              <div class="col-md-12 col-12 mb-1">
                <p class="m-0">اطلاعات سرفصل</p>
              </div>
              <div class="col-md-12 col-12">
                <BnpGrid v-if="$store.state.renderComponentGrid" :propsRows="rows" :propsColumn="columns" :NoSearch="true" :NoPagination="true" :action="false" :hasRowNum="false" :Sortable="true"> </BnpGrid>
              </div>
              <div class="col-md-12 col-12">
                <div class="row">
                  <div class="col-6" style="white-space: nowrap">
                    <span>مجموع مبالغ: </span>
                    <span> {{ $Comma3ragham(SumMab) }} </span>
                  </div>
                  <div v-if="DiffMab == 0" class="col-6 text-success" style="white-space: nowrap">
                    <span>اختلاف سند و مجموع: </span>
                    <span>{{ $Comma3ragham(DiffMab) }}</span>
                  </div>
                  <div v-else class="col-6 text-danger" style="white-space: nowrap">
                    <span>اختلاف سند و مجموع: </span>
                    <span>{{ $Comma3ragham(DiffMab) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- اطلاعات سرفصل -->

            <div v-if="LoadItem" class="row float-left">
              <div class="col-md-12 col-12">
                <hr />
                <button class="btn btn-outline-danger m-2" type="button" tabindex="40" @click="GoToSanad">مشاهده سند قبلی {{ ShomareBackSanad }}</button>
                <button class="btn btn-outline-orange m-2" type="button" tabindex="41">اسناد روز کاربر</button>
                <button class="btn btn-outline-danger m-2" type="button" tabindex="42" @click="FormNew()">جدید</button>
              </div>
            </div>
          </div>
          <!--اطلاعات و مشخصات عضو -->
        </div>
      </template>
    </card>
    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="'Lg'">
      <template v-slot:body>
        <search-taahod v-if="modal1" @Taahod="GetTaahodSearched"> </search-taahod>
        <search-taahod v-if="modal3" @Taahod="GetTaahodSearchedTaraf"> </search-taahod>
        <show-perferaj v-if="modal2 && $store.state.renderComponentperferaj == true && IsShowPerferaj == true" :b_NoePerf="Data[0].b_NoePerf" :tblTaahodatId="Data[0].TaahodatId" :tblSanadId="DataSabtDaem[0].b_SanadId"> </show-perferaj>
      </template>

      <template v-slot:footer> </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import Num2persian from 'num2persian'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import Modal from '@/pages/Modal/Modal.vue'
import SearchTaahod from './SearchTaahod.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import ShowPerferaj from '@/components/BnpCash/CmpPerforage/ShowPerferaj.vue'
export default {
  components: { Card, datePicker: VuePersianDatetimePicker, BnpGrid, Modal, SearchTaahod, SearchableCombo, ShowPerferaj },
  data() {
    return {
      modal1: false,
      modal2: false,
      modal3: false,
      rows: [],
      columns: [
        { label: 'Id', name: 'Id', visibility: false },
        { label: 'نام بانک/باجه', name: 'SharhSarfasl' },
        { label: 'مانده قبل', name: 'ManSarBefore' },
        { label: 'مبلغ', name: 'Mab' },
        { label: 'مانده جدید', name: 'ManSarAfter' },
      ],

      DataAxios_Pardakht: { ArryfildValue: {} },
      DataAxois_DataSearchVcode: { ArryfildValu: {} },
      txtVCode: null,
      txtvCodeTaraf: null,
      DataAxios_FindShomareHesabOrTaahodat: { ArryfildValue: {} },
      DataAxios_FindComplatevCodeTaraf: { ArryfildValue: {} },
      DataAxios_JameBedehiSerResidShode: { ArryfildValue: {} },
      DataAxios_GetImg: {
        ArryfildValue: {},
        Method: 'Get',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_AmarAghsatVam: {
        ArryfildValue: {},
        Method: 'Post',
        Action: '',
        Token: this.$session.get('Token'),
      },
      DataAxios_ManSarBefore: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Pardakht/b_ManSarBefore',
        Token: this.$session.get('Token'),
      },
      DataAxios_Memo: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Pardakht/b_GetMemo',
        Token: this.$session.get('Token'),
      },
      DataAxios_tblaza: {
        ArryfildValue: null,
        Method: 'Get',
        Action: 'AzaInfo',
      },
      DataAxios_GetSnadMovaghat: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'SanadRizNew/b_AddSanadMovaghat',
        Token: this.$session.get('Token'),
      },
      DataSnadRiz: { ItemValue: {} },
      DataAxios_SnadRiz: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'Pardakht/b_AddSanadRizMovaghat',
        Token: this.$session.get('Token'),
      },
      DattAxios_DataSabtDaem: { ArryfildValue: {} },
      FinalDataAxios_DataSabtDaem: {
        ArryfildValue: {},
        Method: 'Post',
        Action: 'SanadRizNew/SabtDaemiSanad',
        Token: this.$session.get('Token'),
      },
      DataAxios_GetSanadId: {
        ArryfildValue: {},
        Action: '',
        Method: 'Get',
        Token: this.$session.get('Token'),
      },
      b_Moshaxasat: null,
      b_ShomareOzvText: null,
      b_DesNoeText: null,
      lblMoshaxasat: null,
      txtMandeBefore: null,
      txtGhabeleBardasht: null,
      txtMoavaghe: null,
      txtMasdood: null,
      txtMandeAfter: null,
      txtMoavagheMazmonin: null,
      LoadItem: false,
      txtMab: 0,
      txtRavesh: 1,
      tempPic: null,
      tempSignature: null,
      gellery: null,
      txtShenase: 0,
      rdiNaghdi: false,
      rdiBanki: false,
      rdiTarkibi: false,
      rdiAzHesab: false,
      rdiHavaleCheck: false,
      PublicFilde: false,
      IsChandGane: false,
      txtMabTaraf: 0,
      TblSarfaslTypeId: null,
      txtMabBank: 0,
      txtMabTashilat: 0,
      txtSarResidGhest: 0,
      txtMabGhest: 0,
      txtTedadGhestVam: 0,
      txtTedadAlbaghi: 0,
      txtTedadGhestMoavaghe: 0,
      txtMablaghMoavaghe: 0,
      TedadAghsatPardaxtNaShode: 0,
      TedadAghsatPardaxtShode: 0,
      txtSumDirPar: 0,
      txtSumZodPar: 0,
      LoadItemTaraf: false,
      txtSeriTaraf: 0,
      tempSignatureTaraf: null,
      tempPicTaraf: null,
      txtTarafMojodiAvalie: 0,
      txtTarafMasdood: 0,
      txtTarafGHabelBardasht: 0,
      txtTarafMandeJadid: 0,
      SarfaslHayeMojazFilter: null,
      MablaghSharj: 0,
      MablaghGhestVam: 0,
      TaahodatId: 0,
      TblAzaId: 0,
      txtDes: '',
      TarixGhest: '',
      txtVarizkonande: '',
      txtFish: '',
      IsGoSandDaem: false,
      LoadSharh: false,
      txtDesBank: '',
      txtFishNoPos: '',
      txtMabTarafrdiAzHesab: 0,
      RizIdTaraf: 0,
      TblSarfaslIdTaraf: 0,
      txtMabBankTaraf: 0,
      txtMabNaghdiTaraf: 0,
      txtMabBankTarkibi: 0,
      txtMabTarafTarkibi: 0,
      IsChandGaneTarkibi: false,
      txtMabBankTarkibiChandGane: 0,
      ShomareBackSanad: 0,
      IsShowPerferaj: false,
      IsPrinted: false,
      //#region پر نمودن متغيرهاي عمومي جهت ثبت سند
      b_TaahodId: null,
      b_NoeId: 0,
      b_IsJarime: false,
      b_SarfaslIdKarmozd: 0,
      b_DarsadJarimeString: 0.0,
      b_DarKar: 0.0,
      b_SarfaslId: 0,
      b_AzaId: 0,
      b_AzaNoeId: 0,
      tblSarfaslTypeId: 0,
      b_IsHavalejat: false,
      b_TaahodatRizId: null,
      b_NahvePardaxt: 0,

      //#endregion

      DataSearchVcode: [
        {
          Id: 0,
          TblShobeId: 1,
          TblNoeId: 0,
          TblAzaId: 0,
          Vcode: '',
          Vcode2: null,
          ShomareOzv: '',
          BirthDate: '',
          OzvName: '',
          OzvFamily: '',
          Pedar: '',
          MablaghMasdod: 0,
          Mande: 0,
          TblCashImageIdPic: 0,
          TblCashImageIdEmza1: 0,
          TblSarfaslTypeId: 0,
          DesNoe: '',
          TblSarfaslId: 0,
          MablaghSharj: 0,
          MablaghGhestVam: 0,
          TblGrpId: 0,
          CanViewMande: true,
          CanDarPar: true,
          TblAzaNoeId: 0,
          HasSharayetBardasht: false,
          SharayetBardasht: '',
          PerNo: null,
          GetKarmozdDasti: false,
          TblSarfaslIdKarmozd: null,
          DarsadKarmozd: 0,
          TblComboNahveMohasebeKarmozd27: 0,
          NameFamily: '',
          MablaghVojohEdareShode: 0,
          VojohEdareShode: false,
          PishFarzSharj: 0,
          MablaghVam: 0,
          TblComboNoeKarmozd6: null,
          TedadGhestVam: 0,
          ModatSep: null,
          PrgDore: 1,
          TblComboPrgVahed4: 10,
          ReturnSoodOrKarmozdIfTasfie: false,
          MabBaseForPas: 0,
          Tarix: '1400/01/28',
          TblTaahodatIdBackup: -1,
          VCodeBackup: null,
          MandeBackup: null,
          TblComboIdMalekiat24: 0,
          MasdoodBackup: null,
          TblSarfaslIdBackup: null,
          TarixShoroAghsat: '',
          IsJarime: false,
          DarsadJarime: 0,
          HesabIsClose: false,
          ExpireDateSendSms: '',
          CodeMeli: '0007700040',
          TarixLastChapGardesh: null,
          MinTarGhestBedehkar: '',
          SumMabPar: 0,
          TedadGhestPar: 0,
          SumMabMoavaghe: 0,
          TedadMoavaghe: 0,
          SumMabBedehi: 0,
          TedadBedehi: 0,
          SumZodPar: 0,
          SumDirPar: 0,
          VcodeEdametxt: null,
          SumBedehiBeDigaran: 0,
          HazineSodorDaftarche: 0,
          TblSarfaslIdDaramadeSodorDaftarche: null,
          MinMabEnsedad: 0,
          Shenase: '',
          TblSarfaslIdBankTarafHesab: null,
          ShenaseVariz: '',
          Mobile: '',
          isXas: false,
          MabVamKol: null,
        },
      ],
      Data: [
        {
          TarixSanad: '1400/11/03',
          TblSarfaslIdBankTarafHesab: 0,
          ChandGane: false,
          b_sarId: 0,
          TblBabkIdTaraf: 0,
          TblBankIdTarkibi: 0,
          b_NoePerf: 0,
          TaahodatId: 0,
        },
      ],
      DataSanadRiz: [
        {
          ShowJoze: false,
          Id: 0,
          tblSanadId: '',
          tblSarfaslId: '',
          tblSanadRizIdTarafHesab: '',
          Vcode: '',
          tblTaahodatId: '',
          tblTaahodatRizId: '',
          tblAzaIdTafsili: '',
          SharhSanadRiz: '',
          Bestan: '0',
          Bedeh: '0',
          BedBes: 0,
          DesSanadRiz: '',
          FishNoRahgiri: '',
          NameFamily: '',
          ShomareOzv: '',
          WithJoze: false,
          Taahodtxt: '',
          tblChkSareHesabId: '',
          tblCheckVaDaftarcheMoshtariRizId: '',
          tblCheckBankiRizId: '',
          SerialCheckBanki: null,
          SerialChkSarHesab: null,
          SerialCheckMoshtari: null,
          CodeSarfasl: '',
          CodeSarfasl2: '',
          ZamanInsert: '',
          Done: true,
          tblAzaId: 0,
          tblComboIdNahvePardaxt29: 0,
          tblComboIdNoeSanad5: 0,
          ShomareSanad: 0,
          TarixSanad: '',
          SharhSanad: '',
          tblSanadIdSodVaZian: null,
          tblSanadIdEftetahie: null,
          tblSanadIdExtetamie: null,
          tblComboIdVaziyat17: '',
          TblSarfaslTypeId: null,
          tblAsnadZemanatiId: null,
          IsUserDeleted: false,
          tblTaahodatIdMortabet: null,
          VCodeMortabet: null,
          tblTaahodatIdEnteghalSarfasl: null,
          TarixCheckBanki: null,
          tblCheckMoshtariId: null,
          tblCheckMoshtariId2: null,
          tblShobeId: 1,
          Varizkonande: null,
          tblTaahodatIdKarmozd: null,
          SahebKarmozd: null,
          SharhSarfaslGoroh: '',
          SharhSarfaslKol: '',
          CodeKol: '0',
          SharhSarfaslMoein: '',
          CodeMoein: '0',
          SharhCodeSarfaslJoze: '',
          SharhSarfaslJoze: '',
          CodeSarfaslJoze: '',
          IsTaeid: 0,
        },
      ],
      DataSabtDaem: [
        {
          b_Stop: 0,
          b_SmSiSendShod: 0,
          RunCompilite: 1,
          b_SanadId: 0,
          b_ShomareSanad: 0,
          b_ErrorMsg: null,
        },
      ],
      ShowDataSanad: [{}],
      AzaPasAndJariRowData: [{}],
      AzaTashilatsRowData: [{}],
      AzaInfoEditData: [{}],
    }
  },
  computed: {
    Mab2persian() {
      return Num2persian(this.txtMab)
    },
    chkChandGane: {
      get() {
        return this.IsChandGane
      },
      set(value) {
        this.IsChandGane = value
        this.rows = []
      },
    },
    chkChandGaneTarkibi: {
      get() {
        return this.IsChandGaneTarkibi
      },
      set(value) {
        this.IsChandGaneTarkibi = value
        this.rows = []
      },
    },
    SumMab() {
      var sum = 0
      if (this.rows.length > 0) {
        for (let index = 0; index < this.rows.length; index++) {
          sum = Number(this.rows[index].Mab.replace(/,/g, '')) + Number(sum)
        }
      }
      return sum
    },
    DiffMab() {
      var sum = 0
      var diff = 0
      if (this.rows.length > 0) {
        for (let index = 0; index < this.rows.length; index++) {
          sum = Number(this.rows[index].Mab.replace(/,/g, '')) + Number(sum)
        }
      }

      if (this.txtMab != 0) {
        diff = Number(this.txtMab.replace(/,/g, '')) - sum
      } else {
        diff = this.txtMab - sum
      }

      return diff
    },
  },
  created() {
    this.DataAxios_Pardakht.ArryfildValue.TarixSanad = this.$store.state.JalaliDate
  },
  mounted() {
    if (this.$store.state.TanzimatPublic.uniqueSerialVcode == true || this.$store.state.TanzimatPublic.uniqueSerialVcodeJustForVam == true) {
      this.$refs.txtVCode.focus()
    }
    this.$refs.txtVCode.focus()
    this.BackSanad(this.DataSabtDaem[0])
  },
  updated() {
    this.$PutCommatoInput()
  },
  beforeDestroy() {
    if ((this.txtMab == '') | (this.txtMab == 0)) {
      this.txtMab = 1
    }
  },
  methods: {
    btnSearchVcode() {
      this.modal1 = true
      this.$store.state.Modal = true
      this.$refs.txtVCode.focus()
    },
    btnSearchVcodeTaraf() {
      this.modal3 = true
      this.$store.state.Modal = true
      this.$refs.txtvCodeTaraf.focus()
    },
    btnSabt() {
      return new Promise((success, error) => {
        var IsTraz = this.DiffMab
        var CheckMablagh=this.txtMab;
        if(CheckMablagh==0 || CheckMablagh==null){
          this.$store.state.loading = false
          this.$mySweetDefaultTost( "", "لطفا مبلغ سند را وارد نمایید!", "info", 1500 );
          error(`error`);
        }
        else{
        if (IsTraz != 0) {
          this.$mySweetDefaultTost('', 'لطفا سند را تراز نمایید!', 'info', 1500)
          error(`error`)
        } else {
          let tblSanadId
          let ShomareSanad
          //درج سربرگ سند
          this.DataAxios_GetSnadMovaghat.ArryfildValue = JSON.parse(JSON.stringify(this.$store.state.SanadRizNew.Data[0]))
          this.DataAxios_GetSnadMovaghat.ArryfildValue.TblDoreId = this.$store.state.DoreMaliData[0].Id
          this.DataAxios_GetSnadMovaghat.ArryfildValue.SharhSanad = this.txtDes
          this.DataAxios_GetSnadMovaghat.ArryfildValue.TblComboIdNoeSanad5 = 5438
          this.DataAxios_GetSnadMovaghat.ArryfildValue.TarixSanad = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
          this.DataAxios_GetSnadMovaghat.ArryfildValue.IsAuto = 1
          var mab = this.txtMab + ''
          let MablaghSanad = mab == 0 ? 0 : mab.replace(/,/g, '').replace(/\./g, '')
          this.$PostData(this.DataAxios_GetSnadMovaghat)
            .then((result) => {
              this.DataSnadRiz.ItemValue.tblSanadId = result.ReturnId
              this.DataSnadRiz.ItemValue.ShomareSanad = result.ShomareSanad
              tblSanadId = result.ReturnId
              ShomareSanad = result.ShomareSanad
            })
            .finally(() => {
              //درج ریز سند
              //آماده کردن اطلاعات برای درج ردیف سند ریز
              this.DataAxios_SnadRiz.ArryfildValue = JSON.parse(JSON.stringify(this.DataSanadRiz[0]))
              this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
              this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = this.txtDes
              this.DataAxios_SnadRiz.ArryfildValue.tblTaahodatId = this.b_TaahodId
              this.DataAxios_SnadRiz.ArryfildValue.Bedeh = MablaghSanad
              this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFish
              this.DataAxios_SnadRiz.ArryfildValue.Bestan = 0
              this.DataAxios_SnadRiz.ArryfildValue.tblTaahodatRizId = this.b_TaahodatRizId
              this.DataAxios_SnadRiz.ArryfildValue.Varizkonande = this.txtVarizkonande
              this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.b_SarfaslId
              this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
              this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
              //  console.log(this.DataAxios_SnadRiz);
              this.$PostData(this.DataAxios_SnadRiz)
                .then((result) => {
                  if (result.status != 'Ok') {
                    this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                  } else {
                    this.DataAxios_SnadRiz.ArryfildValue = JSON.parse(JSON.stringify(this.DataSanadRiz[0]))
                    this.DataAxios_SnadRiz.ArryfildValue.tblSanadRizIdTarafHesab = result.tblSanadRizIdTarafHesab
                  }
                })
                .finally(() => {
                  if (this.rdiNaghdi) {
                    //روش نقدی
                    this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
                    this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.rows[0].Id
                    this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = this.txtDes
                    this.DataAxios_SnadRiz.ArryfildValue.Bedeh = 0
                    this.DataAxios_SnadRiz.ArryfildValue.Bestan = MablaghSanad
                    this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFish
                    this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
                    this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                    // console.log(this.DataAxios_SnadRiz);
                    this.$PostData(this.DataAxios_SnadRiz).then((result) => {
                      if (result.status != 'Ok') {
                        this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                      } else {
                        this.IsGoSandDaem = true
                        //ثبت دائمی سند
                        if (this.IsGoSandDaem) {
                          this.DattAxios_DataSabtDaem.ArryfildValue.TarixSanad = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadMovaghatId = tblSanadId
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_ShomareSanad = ShomareSanad
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_ShobeId = this.$session.get('UserInfo').tblShobeId
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_UserId = this.$session.get('UserInfo').tblUserId
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadDate = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_DeleteMovaghat = true
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadId = ''
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_Checking = false
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_DoreId = this.$store.state.DoreMaliData[0].Id
                          this.DattAxios_DataSabtDaem.ArryfildValue.b_UserGrpId = this.$session.get('UserInfo').tblUserGrpId

                          let b_SabtSandDaem = {
                            ...this.DattAxios_DataSabtDaem.ArryfildValue,
                            ...this.$store.state.b_SabtSandDaem[0],
                          }
                          this.FinalDataAxios_DataSabtDaem.ArryfildValue = b_SabtSandDaem
                          this.$PostData(this.FinalDataAxios_DataSabtDaem)
                            .then((result) => {
                              if (result.length > 0) {
                                this.DataSabtDaem[0] = result[0]
                                var msg = 'سند با شماره ' + result[0].b_ShomareSanad + ' با موفقیت ثبت شد'
                                this.$mySweetDefaultTost('', msg, 'success', 2000)
                              } else {
                                this.$mySweetDefaultTost('', 'اس پی ثبت سند وجود ندارد و یا مشکلی در آن بوجودآمده است!', 'warning', 1000)
                              }
                            })
                            .finally(() => {
                              success('success')
                              this.b_AfterCompleted()
                            })
                        }
                        //ثبت دائمی سند
                      }
                    })
                  }
                  if (this.rdiBanki) {
                    //روش بانکی
                    for (let index = 0; index < this.rows.length; index++) {
                      this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
                      this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.rows[index].Id
                      this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = this.txtDesBank
                      this.DataAxios_SnadRiz.ArryfildValue.Bedeh = 0
                      this.DataAxios_SnadRiz.ArryfildValue.Bestan = this.rows[index].Mab
                      this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFishNoPos
                      this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
                      this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                      this.$PostData(this.DataAxios_SnadRiz).then((result) => {
                        if (result.status != 'Ok') {
                          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                        } else {
                          this.IsGoSandDaem = true
                        }
                      })
                    }
                    this.DattAxios_DataSabtDaem.ArryfildValue.TarixSanad = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadMovaghatId = tblSanadId
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_ShomareSanad = ShomareSanad
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_ShobeId = this.$session.get('UserInfo').tblShobeId
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_UserId = this.$session.get('UserInfo').tblUserId
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadDate = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_DeleteMovaghat = true
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadId = ''
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_Checking = false
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_DoreId = this.$store.state.DoreMaliData[0].Id
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_UserGrpId = this.$session.get('UserInfo').tblUserGrpId

                    let b_SabtSandDaem = {
                      ...this.DattAxios_DataSabtDaem.ArryfildValue,
                      ...this.$store.state.b_SabtSandDaem[0],
                    }
                    this.FinalDataAxios_DataSabtDaem.ArryfildValue = b_SabtSandDaem
                    console.log(this.FinalDataAxios_DataSabtDaem)
                    this.$PostData(this.FinalDataAxios_DataSabtDaem)
                      .then((result) => {
                        if (result.length > 0) {
                          this.DataSabtDaem[0] = result[0]
                          var msg = 'سند با شماره ' + result[0].b_ShomareSanad + ' با موفقیت ثبت شد'
                          this.$mySweetDefaultTost('', msg, 'success', 2000)
                        } else {
                          this.$mySweetDefaultTost('', 'اس پی ثبت سند وجود ندارد و یا مشکلی در آن بوجودآمده است!', 'warning', 1000)
                        }
                      })
                      .finally(() => {
                        success('success')
                        this.b_AfterCompleted()
                      })
                  }
                  if (this.rdiAzHesab) {
                    //روش حسابی
                    let mabTaraf
                    let mablaghSanadTaraf

                    if (this.txtMabBankTaraf != 0) {
                      mabTaraf = this.txtMabBankTaraf + ''
                      mablaghSanadTaraf = mabTaraf == 0 ? 0 : mabTaraf.replace(/,/g, '').replace(/\./g, '')
                      this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
                      this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.Data[0].TblBabkIdTaraf
                      this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = 'پرداخت بانكي' + this.$b_InvertCode(this.txtVCode, '-')
                      this.DataAxios_SnadRiz.ArryfildValue.Bedeh = 0
                      this.DataAxios_SnadRiz.ArryfildValue.Bestan = mablaghSanadTaraf
                      this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFishNoPos
                      this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
                      this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                      this.$PostData(this.DataAxios_SnadRiz).then((result) => {
                        if (result.status != 'Ok') {
                          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                        }
                      })
                    }
                    if (this.txtMabNaghdiTaraf != 0) {
                      mabTaraf = this.txtMabNaghdiTaraf + ''
                      mablaghSanadTaraf = mabTaraf == 0 ? 0 : mabTaraf.replace(/,/g, '').replace(/\./g, '')
                      this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
                      this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.$store.state.TanzimatPublic.tblSarfaslIdSandoghPishfarz
                      this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = 'پرداختی نقدی' + this.$b_InvertCode(this.txtVCode, '-')
                      this.DataAxios_SnadRiz.ArryfildValue.Bedeh = 0
                      this.DataAxios_SnadRiz.ArryfildValue.Bestan = mablaghSanadTaraf
                      this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFishNoPos
                      this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
                      this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                      this.$PostData(this.DataAxios_SnadRiz).then((result) => {
                        if (result.status != 'Ok') {
                          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                        }
                      })
                    }
                    mabTaraf = this.txtMabTarafrdiAzHesab + ''
                    mablaghSanadTaraf = mabTaraf == 0 ? 0 : mabTaraf.replace(/,/g, '').replace(/\./g, '')
                    this.DataAxios_SnadRiz.ArryfildValue = JSON.parse(JSON.stringify(this.DataSanadRiz[0]))
                    this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
                    this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = 'واریز بابت حساب / تسهیلات' + this.$b_InvertCode(this.txtVCode, '-')
                    this.DataAxios_SnadRiz.ArryfildValue.tblTaahodatId = this.RizIdTaraf
                    this.DataAxios_SnadRiz.ArryfildValue.Bedeh = 0
                    this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFish
                    this.DataAxios_SnadRiz.ArryfildValue.Bestan = mablaghSanadTaraf
                    this.DataAxios_SnadRiz.ArryfildValue.Varizkonande = this.txtVarizkonande
                    this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.TblSarfaslIdTaraf
                    this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
                    this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                    this.$PostData(this.DataAxios_SnadRiz)
                      .then((result) => {
                        if (result.status != 'Ok') {
                          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                        }
                        //  درج ریز سند طرف
                      })
                      .finally(() => {
                        this.DattAxios_DataSabtDaem.ArryfildValue.TarixSanad = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadMovaghatId = tblSanadId
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_ShomareSanad = ShomareSanad
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_ShobeId = this.$session.get('UserInfo').tblShobeId
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_UserId = this.$session.get('UserInfo').tblUserId
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadDate = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_DeleteMovaghat = true
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadId = ''
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_Checking = false
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_DoreId = this.$store.state.DoreMaliData[0].Id
                        this.DattAxios_DataSabtDaem.ArryfildValue.b_UserGrpId = this.$session.get('UserInfo').tblUserGrpId

                        let b_SabtSandDaem = {
                          ...this.DattAxios_DataSabtDaem.ArryfildValue,
                          ...this.$store.state.b_SabtSandDaem[0],
                        }
                        this.FinalDataAxios_DataSabtDaem.ArryfildValue = b_SabtSandDaem
                        this.$PostData(this.FinalDataAxios_DataSabtDaem)
                          .then((result) => {
                            if (result.length > 0) {
                              this.DataSabtDaem[0] = result[0]
                              var msg = 'سند با شماره ' + result[0].b_ShomareSanad + ' با موفقیت ثبت شد'
                              this.$mySweetDefaultTost('', msg, 'success', 2000)
                              this.DataAxios_SnadRiz.ArryfildValue = JSON.parse(JSON.stringify(this.DataSanadRiz[0]))
                            } else {
                              this.$mySweetDefaultTost('', 'اس پی ثبت سند وجود ندارد و یا مشکلی در آن بوجودآمده است!', 'warning', 1000)
                            }
                          })
                          .finally(() => {
                            success('success')
                            this.b_AfterCompleted()
                          })
                      })
                  }
                  if (this.rdiTarkibi) {
                    //روش ترکیبی
                    for (let index = 0; index < this.rows.length; index++) {
                      this.DataAxios_SnadRiz.ArryfildValue.tblSanadId = this.DataSnadRiz.ItemValue.tblSanadId
                      this.DataAxios_SnadRiz.ArryfildValue.tblSarfaslId = this.rows[index].Id
                      this.DataAxios_SnadRiz.ArryfildValue.SharhSanadRiz = this.txtDes
                      this.DataAxios_SnadRiz.ArryfildValue.Bedeh = 0
                      this.DataAxios_SnadRiz.ArryfildValue.Bestan = this.rows[index].Mab
                      this.DataAxios_SnadRiz.ArryfildValue.FishNoRahgiri = this.txtFish
                      this.DataAxios_SnadRiz.ArryfildValue.tblComboIdNahvePardaxt29 = this.b_NahvePardaxt
                      this.DataAxios_SnadRiz.ArryfildValue.tblUserGrpIdInsert = this.$session.get('UserInfo').tblUserGrpId
                      this.$PostData(this.DataAxios_SnadRiz).then((result) => {
                        if (result.status != 'Ok') {
                          this.$mySweetDefaultTost('عدم وجود اطلاعات', 'خطا در درج اطلاعات ریز سند', 'warning', 1000)
                        } else {
                          this.IsGoSandDaem = true
                        }
                      })
                    }
                    //ثبت دائمی سند
                    this.DattAxios_DataSabtDaem.ArryfildValue.TarixSanad = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadMovaghatId = tblSanadId
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_ShomareSanad = ShomareSanad
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_ShobeId = this.$session.get('UserInfo').tblShobeId
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_UserId = this.$session.get('UserInfo').tblUserId
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadDate = this.DataAxios_Pardakht.ArryfildValue.TarixSanad
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_DeleteMovaghat = true
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_SanadId = ''
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_Checking = false
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_DoreId = this.$store.state.DoreMaliData[0].Id
                    this.DattAxios_DataSabtDaem.ArryfildValue.b_UserGrpId = this.$session.get('UserInfo').tblUserGrpId

                    let b_SabtSandDaem = {
                      ...this.DattAxios_DataSabtDaem.ArryfildValue,
                      ...this.$store.state.b_SabtSandDaem[0],
                    }
                    this.FinalDataAxios_DataSabtDaem.ArryfildValue = b_SabtSandDaem
                    this.$PostData(this.FinalDataAxios_DataSabtDaem)
                      .then((result) => {
                        if (result.length > 0) {
                          this.DataSabtDaem[0] = result[0]
                          var msg = 'سند با شماره ' + result[0].b_ShomareSanad + ' با موفقیت ثبت شد'
                          this.$mySweetDefaultTost('', msg, 'success', 2000)
                        } else {
                          this.$mySweetDefaultTost('', 'اس پی ثبت سند وجود ندارد و یا مشکلی در آن بوجودآمده است!', 'warning', 1000)
                        }
                      })
                      .finally(() => {
                        success('success')
                        this.b_AfterCompleted()
                      })

                    //ثبت دائمی سند
                  }
                })
            })
        }
        }
      })
    },
    ShowPerferaj() {
      this.IsPrinted = true
      this.btnSabt().then((data) => {
        if (data == 'success') {
          this.IsPrinted = true
        }
      })
    },
    b_AfterCompleted() {
      if (this.IsPrinted) {
        this.Data[0].TaahodatId = this.TaahodatId
        this.Data[0].b_NoePerf = this.b_SarfaslId == 1 ? 5436 : 5434
        this.$store.state.renderComponentperferaj = false
        this.$nextTick(() => {
          this.$store.state.renderComponentperferaj = true
          this.IsShowPerferaj = true
        })
        document.getElementById('btnShowModalPer').click()
        this.FormNew()
      } else {
        this.FormNew()
      }
    },
    ComplateVcode(e) {
      if (e.target.value != '') {
        this.DataAxios_FindShomareHesabOrTaahodat.ArryfildValue.Vcode = e.target.value
        this.DataAxios_FindShomareHesabOrTaahodat.ArryfildValue.id = this.$session.get('UserInfo').tblGrpId
        this.DataAxios_FindShomareHesabOrTaahodat.Method = 'Post'
        this.DataAxios_FindShomareHesabOrTaahodat.Action = 'SearchTaahod/b_GetDataTaahod'
        this.$PostData(this.DataAxios_FindShomareHesabOrTaahodat).then((data) => {
          if (data.eNum == '1010') {
            this.$mySweetDefaultTost('عدم وجود اطلاعات', data.msg, 'info', 1500)
            this.txtVCode = null
            this.$refs.txtVCode.focus()
          } else {
            if (data.CanDarPar != true) {
              this.$mySweetDefaultTost('عدم دسترسی', 'شما مجاز به پرداخت از اين شماره نمي باشيد با راهبر تماس بگيريد!', 'info', 1500)
              this.txtVCode = null
              this.$refs.txtVCode.focus()
              return
            }
            if (data.HesabIsClose) {
              //باز بودن حساب
              this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اين حساب بسته شده و امكان صدور سند براي آن نيست!"', 'info', 1500)
              this.txtVCode = null
              this.$refs.txtVCode.focus()
              return
            }
            if (data.TblSarfaslTypeId != 1) {
              this.LoadItem = true
              this.LoadItemTaraf = false
              //گرفتن اطلاعات تعهد
              this.DataSearchVcode[0] = data
              this.TblAzaId = data.TblAzaId
              this.TaahodatId = data.Id
              this.txtVCode = data.Vcode
              this.b_Moshaxasat = data.OzvName + ' ' + data.OzvFamily
              this.b_ShomareOzvText = data.ShomareOzv
              this.b_DesNoeText = data.DesNoe
              this.lblMoshaxasat = this.b_Moshaxasat + ' / ' + this.$b_InvertCode(this.txtVCode, '-') + ' / ' + this.b_DesNoeText
              this.txtMandeBefore = this.$Comma3ragham(data.Mande + data.MablaghVojohEdareShode)
              this.txtGhabeleBardasht = this.$Comma3ragham(data.Mande - data.MablaghMasdod)
              this.txtMasdood = this.$Comma3ragham(data.MablaghMasdod)
              this.txtMandeAfter = this.txtGhabeleBardasht
              this.txtShenase = data.Shenase
              this.TblSarfaslTypeId = data.TblSarfaslTypeId
              this.MablaghGhestVam = data.MablaghGhestVam
              this.MablaghSharj = data.MablaghSharj
              // //#region جزئیات تسهیلات
              // this.txtMabTashilat=this.$Comma3ragham(data.MablaghVam)
              // this.txtSarResidGhest=this.$Comma3ragham(data.MinTarGhestBedehkar)
              // this.txtMabGhest=this.$Comma3ragham(data.MablaghGhestVam)
              // this.txtTedadGhestVam=this.$Comma3ragham(data.TedadGhestVam)
              // this.txtTedadAlbaghi=this.$Comma3ragham(data.TedadBedehi)
              // this.txtTedadGhestMoavaghe=this.$Comma3ragham(data.TedadMoavaghe)
              // this.txtSumZodPar=this.$Comma3ragham(data.SumZodPar)
              // this.txtSumDirPar=this.$Comma3ragham(data.SumDirPar)
              // //#endregion

              //#region  نمايش ميزان معوقات
              this.DataAxios_JameBedehiSerResidShode.ArryfildValue.tblAzaId = data.TblAzaId
              this.DataAxios_JameBedehiSerResidShode.Method = 'Post'
              this.DataAxios_JameBedehiSerResidShode.Action = 'Pardakht/b_GetJameBedehiSerResidShode'
              this.$PostData(this.DataAxios_JameBedehiSerResidShode).then((dataBedehi) => {
                this.txtMoavaghe = this.$Comma3ragham(dataBedehi[0].JameResidShode)
                this.txtMoavagheMazmonin = this.$Comma3ragham(dataBedehi[0].JameResidShodeMazmonin)
                this.txtMablaghMoavaghe = this.$Comma3ragham(data.SumMabMoavaghe)
              })
              //#endregion
              //#region نمایش تصویر مشتری
              if (data.TblCashImageIdPic != 0) {
                this.DataAxios_GetImg.ArryfildValue = null
                this.DataAxios_GetImg.Method = 'Post'
                this.DataAxios_GetImg.Action = 'TblImageCash/Index/?Id=' + data.TblCashImageIdPic
                var tblCashImageIdPic
                this.$PostData(this.DataAxios_GetImg)
                  .then((data) => {
                    tblCashImageIdPic = data.img
                  })
                  .finally(() => {
                    if (tblCashImageIdPic != null) {
                      this.tempPic = 'data:image/png;base64,' + tblCashImageIdPic
                    } else {
                      this.tempPic = null
                    }
                  })
              }
              //#endregion
              //#region نمایش امضا مشتری
              if (data.TblCashImageIdEmza1 != 0) {
                this.DataAxios_GetImg.Action = 'TblImageCash/Index/?Id=' + data.TblCashImageIdEmza1
                this.DataAxios_GetImg.Method = 'Post'
                var TblCashImageIdEmza1
                this.$PostData(this.DataAxios_GetImg)
                  .then((data) => {
                    TblCashImageIdEmza1 = data.img
                  })
                  .finally(() => {
                    if (TblCashImageIdEmza1 != null) {
                      this.tempSignature = 'data:image/png;base64,' + TblCashImageIdEmza1
                    } else {
                      this.tempSignature = null
                    }
                  })
              }
              //#endregion
              this.SetLabels()

              //#region نمایش یادداشت ها
              if (this.$store.state.TanzimatPublic.namayeshYaddasht == true) {
                this.DataAxios_Memo.ArryfildValue.TaahodatId = data.Id
                this.$PostData(this.DataAxios_Memo).then((dataMemo) => {
                  if (dataMemo[0].Yaddasht != null) {
                    this.txtMemo = dataMemo[0].Yaddasht
                    alert(this.txtMemo)
                  }

                  //this.$SweetQustion('نمایش یادداشت', this.txtMemo, 'info', 'تایید', '', null, this.OkMemo , null);
                })
              }
              //#endregion

              //#region پر نمودن متغيرهاي عمومي جهت ثبت سند
              this.b_TaahodId = data.Id
              this.b_NoeId = data.TblNoeId
              this.b_IsJarime = data.IsJarime
              this.b_IsKarmozdDirkerd = data.TblComboNahveMohasebeKarmozd27
              this.b_SarfaslIdKarmozd = data.TblSarfaslIdKarmozd
              this.b_DarsadJarimeString = data.DarsadJarime
              this.b_DarKar = data.DarsadKarmozd
              this.b_SarfaslId = data.TblSarfaslId
              this.b_AzaId = data.TblAzaId
              this.b_AzaNoeId = data.TblAzaNoeId
              this.tblSarfaslTypeId = data.TblSarfaslTypeId
              this.b_IsHavalejat = data.IsHavalejat
              //#endregion
            } else {
              this.$mySweetDefaultTost('ورود اطلاعات اشتباه! ', 'ورود شماره تسهیلات در فرم پرداخت مجاز نیست ', 'info', 2500)
              this.txtVCode = null
              this.LoadItem = false
              this.PublicFilde = false
              this.rdiNaghdi = false
              this.$refs.txtVCode.focus()
            }
          }
        })
      }
    },
    ComplatevCodeTaraf(e) {
      if (e.target.value != '') {
        this.DataAxios_FindComplatevCodeTaraf.ArryfildValue.Vcode = e.target.value
        this.DataAxios_FindComplatevCodeTaraf.ArryfildValue.id = this.$session.get('UserInfo').tblGrpId
        this.DataAxios_FindComplatevCodeTaraf.Method = 'Post'
        this.DataAxios_FindComplatevCodeTaraf.Action = 'SearchTaahod/b_GetDataTaahod'
        this.$PostData(this.DataAxios_FindComplatevCodeTaraf).then((dataTaraf) => {
          if (dataTaraf.eNum == '1010') {
            this.$mySweetDefaultTost('عدم وجود اطلاعات', dataTaraf.msg, 'info', 1500)
            this.txtvCodeTaraf = null
            this.$refs.txtvCodeTaraf.focus()
          } else {
            this.txtvCodeTaraf = dataTaraf.Vcode
            this.LoadItemTaraf = true
            this.lblMoshaxasatTaraf = dataTaraf.OzvName + ' ' + dataTaraf.OzvFamily + ' / ' + this.$b_InvertCode(dataTaraf.Vcode, '-') + ' / ' + dataTaraf.DesNoe
            this.txtTarafMojodiAvalie = this.$Comma3ragham(dataTaraf.Mande)
            this.txtTarafMasdood = this.$Comma3ragham(dataTaraf.MablaghMasdod)
            this.txtTarafGHabelBardasht = this.$Comma3ragham(dataTaraf.Mande - dataTaraf.MablaghMasdod)
            this.RizIdTaraf = dataTaraf.Id
            this.TblSarfaslIdTaraf = dataTaraf.TblSarfaslId

            //#region نمایش تصویر مشتری طرف
            if (dataTaraf.TblCashImageIdPic != 0) {
              this.DataAxios_GetImg.ArryfildValue = null
              this.DataAxios_GetImg.Method = 'Post'
              this.DataAxios_GetImg.Action = 'TblImageCash/Index/?Id=' + dataTaraf.TblCashImageIdPic
              var tblCashImageIdPic
              this.$PostData(this.DataAxios_GetImg)
                .then((dataTaraf) => {
                  tblCashImageIdPic = dataTaraf.img
                })
                .finally(() => {
                  if (tblCashImageIdPic != null) {
                    this.tempPicTaraf = 'data:image/png;base64,' + tblCashImageIdPic
                  } else {
                    this.tempPicTaraf = null
                  }
                })
            }
            //#endregion
            //#region نمایش امضا مشتری طرف
            if (dataTaraf.TblCashImageIdEmza1 != 0) {
              this.DataAxios_GetImg.Action = 'TblImageCash/Index/?Id=' + dataTaraf.TblCashImageIdEmza1
              this.DataAxios_GetImg.Method = 'Post'
              var TblCashImageIdEmza1
              this.$PostData(this.DataAxios_GetImg)
                .then((dataTaraf) => {
                  TblCashImageIdEmza1 = dataTaraf.img
                })
                .finally(() => {
                  if (TblCashImageIdEmza1 != null) {
                    this.tempSignatureTaraf = 'data:image/png;base64,' + TblCashImageIdEmza1
                  } else {
                    this.tempSignatureTaraf = null
                  }
                })
            }
            //#endregion
          }
        })
      }
    },
    GetTaahodSearched(taahod) {
      this.txtVCode = taahod.Vcode
      this.$nextTick(() => {
        document.getElementById('txtVCode').focus()
      })
    },
    GetTaahodSearchedTaraf(taahod) {
      this.txtvCodeTaraf = taahod.Vcode
      this.$nextTick(() => {
        document.getElementById('txtvCodeTaraf').focus()
      })
    },
    SearchVcode(e) {
      //#region PadLeft Vcode
      if (e.key == 'Enter' || e.key == 'Tab') {
        var vcode = this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#')
        e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
        var CodeNoe = e.target.value.substring(0, 3)
        e.target.value = e.target.value.replace(e.target.value.substring(0, 3), '')
        e.target.value = e.target.value.padStart(vcode.length, 0)
        e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + CodeNoe + e.target.value
      }
      //#endregion PadLeft Vcode
    },
    SearchVcodeTaraf(e) {
      if (e.key == 'Enter' || e.key == 'Tab') {
        var vcode = this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#')
        e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
        var CodeNoe = e.target.value.substring(0, 3)
        e.target.value = e.target.value.replace(e.target.value.substring(0, 3), '')
        e.target.value = e.target.value.padStart(vcode.length, 0)
        e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + CodeNoe + e.target.value
      }
    },
    FocusOutMab(e) {
      try {
        if (e.target.value != '0' && e.target.value == '') {
          e.target.value = '0'
          this.$mySweetDefaultTost('خطای ورود اطلاعات', 'مبلغ سند را وارد نمایید', 'info', 1500)
          this.$refs.txtMab.focus()
        }
        if (e.target.value == '0') {
          this.$mySweetDefaultTost('خطای ورود اطلاعات', 'مبلغ سند را وارد نمایید', 'info', 1500)
          this.$refs.txtMab.focus()
        }
      } catch (e) {
        console.log(e)
      }
    },
    FocusOut(e) {
      if (e.target.value != '0' && e.target.value == '') {
        e.target.value = '0'
      }
    },
    FocusOutTarkibi(e) {
      if (e.target.value != '0' && e.target.value == '') {
        e.target.value = '0'
      } else {
        this.rows = []
        var mabNaghdiTarkibi = e.target.value.replace(/,/g, '').replace(/\./g, '')
        this.txtMabBankTarkibi = this.txtMab
        this.txtMabBankTarkibi = Number(this.txtMabBankTarkibi.replace(/,/g, '').replace(/\./g, '')) - Number(mabNaghdiTarkibi)
        this.GetBajeNaghdiTarkibi()
        if (!this.IsChandGaneTarkibi) {
          this.GetBajeBankTarkibi()
        }
      }
    },
    Focus(e) {
      if (e.target.value == '0' || (e.target.value == 0 && e.target.value != '')) {
        e.target.value = ''
      }
    },
    // NumToPersian(e){
    //     this.Mab2persian=Num2persian(e.target.value) + ' ريال '
    // },
    txtRaveshFocus(e) {
      e.target.select()
    },
    txtRaveshFocusOut(e) {
      const val = e.target.value
      if (val > 4 || val < 1) {
        e.target.value = 1
      } else {
        switch (val) {
          case '1':
            this.b_NahvePardaxt = 4118
            this.rdiNaghdi = true
            this.PublicFilde = false
            this.rdiBanki = false
            this.rdiTarkibi = false
            this.rdiAzHesab = false
            this.rdiHavaleCheck = false
            var tblSarfaslIdSandoghPishFarz = this.$store.state.TanzimatPublic.tblSarfaslIdSandoghPishfarz
            this.Data[0].b_sarId = this.$store.state.TanzimatPublic.tblSarfaslIdSandoghPishfarz
            if (tblSarfaslIdSandoghPishFarz != 0 && tblSarfaslIdSandoghPishFarz != null) {
              this.GetBajeBank()
            } else {
              this.$mySweetDefaultTost('عدم وجود اطلاعات', 'اطلاعات باجه پيدا نشد', 'info', 1500)
            }
            break
          case '2':
            this.b_NahvePardaxt = 4119
            this.rdiBanki = true
            this.rdiNaghdi = false
            this.rdiTarkibi = false
            this.rdiAzHesab = false
            this.rdiHavaleCheck = false
            this.PublicFilde = true
            break
          case '3':
            this.b_NahvePardaxt = 4121
            this.rdiBanki = false
            this.rdiNaghdi = false
            this.rdiTarkibi = true
            this.rdiAzHesab = false
            this.rdiHavaleCheck = false
            this.PublicFilde = true
            this.txtMabBankTarkibi = this.txtMab
            break
          case '4':
            this.b_NahvePardaxt = 4120
            this.rdiBanki = false
            this.rdiNaghdi = false
            this.rdiTarkibi = false
            this.rdiAzHesab = true
            this.rdiHavaleCheck = false
            this.PublicFilde = true
            this.txtMabTarafrdiAzHesab = this.txtMab
            break
          case '5':
            this.rdiBanki = false
            this.rdiNaghdi = false
            this.rdiTarkibi = false
            this.rdiAzHesab = false
            this.rdiHavaleCheck = true
            this.PublicFilde = true
            break
          default:
            break
        }
      }
    },
    showimage(event) {
      this.gellery = event.target.src
      document.getElementById('gallery').src = this.gellery
      document.getElementById('fullpage').style['display'] = 'block'
    },
    cancelgallery() {
      document.getElementById('fullpage').style['display'] = 'none'
    },
    getbankId(value) {
      this.Data[0].TblSarfaslIdBankTarafHesab = value.id
      if (value.id != 0 && value.id != null) {
        this.Data[0].b_sarId = value.id
        if (!this.IsChandGane && !this.rdiAzHesab) {
          this.GetBajeBank()
        }
      }
    },
    getbankIdTaraf(value) {
      if (value.id != 0 && value.id != null) {
        this.Data[0].TblBabkIdTaraf = value.id
      }
    },
    getbankIdTarkibi(value) {
      if (value.id != 0 && value.id != null) {
        this.Data[0].TblBankIdTarkibi = value.id
        if (!this.IsChandGaneTarkibi && !this.rdiAzHesab) {
          this.GetBajeBankTarkibi()
        }
      }
    },
    GetBajeBank() {
      let Mande
      let ManSarAfter
      let MablaghSanad
      var mab
      var SarfaslHayeMojaz
      if (this.IsChandGane) {
        mab = this.txtMabTaraf + ''
        MablaghSanad = mab == 0 ? 0 : mab.replace(/,/g, '').replace(/\./g, '')
      } else {
        mab = this.txtMab + ''
        MablaghSanad = mab == 0 ? 0 : mab.replace(/,/g, '').replace(/\./g, '')
      }
      if (this.rdiNaghdi) {
        this.DataAxios_ManSarBefore.ArryfildValue.Id = this.Data[0].b_sarId
        let list = []
        SarfaslHayeMojaz = this.$store.state.SarfaslHayeMojaz
        for (let index = 0; index < SarfaslHayeMojaz.length; index++) {
          if (SarfaslHayeMojaz[index].Id == this.Data[0].b_sarId) {
            this.SarfaslHayeMojazFilter = SarfaslHayeMojaz[index]
            list.push(this.SarfaslHayeMojazFilter)
          }
        }

        this.$PostData(this.DataAxios_ManSarBefore)
          .then((data) => {
            Mande = data[0].ManSarBefore
          })
          .finally(() => {
            ManSarAfter = Number(Mande) - Number(MablaghSanad)
            list[0]['ManSarBefore'] = Mande == null ? 0 : this.$Comma3ragham(Mande)
            list[0]['Mab'] = this.$Comma3ragham(MablaghSanad)
            list[0]['ManSarAfter'] = this.$Comma3ragham(ManSarAfter)

            this.b_AddRowToGrdBajeBank(list)
          })
      }
      if (this.rdiBanki) {
        this.DataAxios_ManSarBefore.ArryfildValue.Id = this.Data[0].b_sarId
        let list = []
        SarfaslHayeMojaz = this.$store.state.SarfaslHayeMojaz
        for (let index = 0; index < SarfaslHayeMojaz.length; index++) {
          if (SarfaslHayeMojaz[index].Id == this.Data[0].b_sarId) {
            this.SarfaslHayeMojazFilter = SarfaslHayeMojaz[index]
            list.push(this.SarfaslHayeMojazFilter)
          }
        }

        this.$PostData(this.DataAxios_ManSarBefore)
          .then((data) => {
            Mande = data[0].ManSarBefore
          })
          .finally(() => {
            ManSarAfter = Number(Mande) - Number(MablaghSanad)
            list[0]['ManSarBefore'] = Mande == null ? 0 : this.$Comma3ragham(Mande)
            list[0]['Mab'] = this.$Comma3ragham(MablaghSanad)
            list[0]['ManSarAfter'] = this.$Comma3ragham(ManSarAfter)

            this.b_AddRowToGrdBajeBank(list)
          })
      }
    },
    GetBajeBankTarkibi() {
      let Mande
      let ManSarAfter
      let MablaghSanad
      var mab
      var SarfaslHayeMojaz

      if (this.txtMabBankTarkibi != 0) {
        if (this.IsChandGaneTarkibi) {
          mab = this.txtMabBankTarkibiChandGane + ''
          MablaghSanad = mab == 0 ? 0 : mab.replace(/,/g, '').replace(/\./g, '')
        } else {
          mab = this.txtMabBankTarkibi + ''
          MablaghSanad = mab == 0 ? 0 : mab.replace(/,/g, '').replace(/\./g, '')
        }
        this.DataAxios_ManSarBefore.ArryfildValue.Id = this.Data[0].TblBankIdTarkibi
        let list = []
        SarfaslHayeMojaz = this.$store.state.SarfaslHayeMojaz
        for (let index = 0; index < SarfaslHayeMojaz.length; index++) {
          if (SarfaslHayeMojaz[index].Id == this.Data[0].TblBankIdTarkibi) {
            this.SarfaslHayeMojazFilter = SarfaslHayeMojaz[index]
            list.push(this.SarfaslHayeMojazFilter)
          }
        }
        this.$PostData(this.DataAxios_ManSarBefore)
          .then((data) => {
            Mande = data[0].ManSarBefore
          })
          .finally(() => {
            ManSarAfter = Number(MablaghSanad) - Number(Mande)
            list[0]['ManSarBefore'] = Mande == null ? 0 : this.$Comma3ragham(Mande)
            list[0]['Mab'] = this.$Comma3ragham(MablaghSanad)
            list[0]['ManSarAfter'] = this.$Comma3ragham(ManSarAfter)
            this.b_AddRowToGrdBajeBank(list)
          })
      }
    },
    GetBajeNaghdiTarkibi() {
      let Mande
      let ManSarAfter
      let MablaghSanad
      var mab
      var SarfaslHayeMojaz
      if (this.txtMabTarafTarkibi != 0) {
        mab = this.txtMabTarafTarkibi + ''
        MablaghSanad = mab == 0 ? 0 : mab.replace(/,/g, '').replace(/\./g, '')
        this.DataAxios_ManSarBefore.ArryfildValue.Id = this.$store.state.TanzimatPublic.tblSarfaslIdSandoghPishfarz
        let list = []
        SarfaslHayeMojaz = this.$store.state.SarfaslHayeMojaz
        for (let index = 0; index < SarfaslHayeMojaz.length; index++) {
          if (SarfaslHayeMojaz[index].Id == this.$store.state.TanzimatPublic.tblSarfaslIdSandoghPishfarz) {
            this.SarfaslHayeMojazFilter = SarfaslHayeMojaz[index]
            list.push(this.SarfaslHayeMojazFilter)
          }
        }

        this.$PostData(this.DataAxios_ManSarBefore)
          .then((data) => {
            Mande = data[0].ManSarBefore
          })
          .finally(() => {
            ManSarAfter = Number(MablaghSanad) - Number(Mande)
            list[0]['ManSarBefore'] = Mande == null ? 0 : this.$Comma3ragham(Mande)
            list[0]['Mab'] = this.$Comma3ragham(MablaghSanad)
            list[0]['ManSarAfter'] = this.$Comma3ragham(ManSarAfter)

            this.b_AddRowToGrdBajeBank(list)
          })
      }
    },
    b_AddRowToGrdBajeBank(list) {
      var savedlist = JSON.parse(JSON.stringify(list))
      this.rows = JSON.parse(JSON.stringify(this.rows))
      if (this.IsChandGane || this.IsChandGaneTarkibi) {
        var sum = 0
        for (let index = 0; index < this.rows.length; index++) {
          sum = Number(sum + this.rows[index].Mab.replace(/,/g, '')) + sum
        }

        if (sum + Number(savedlist[0].Mab.replace(/,/g, '')) > Number(this.txtMab.replace(/,/g, ''))) {
          this.$mySweetDefaultTost('خطا', 'مبلغ وارد شده نمیتواند بیشتر از مبلغ کل سند باشد!', 'warning', 1500)
        } else {
          this.rows.push(JSON.parse(JSON.stringify(savedlist[0])))
        }
      } else if (this.txtMabTarafTarkibi != 0) {
        if (sum + Number(savedlist[0].Mab.replace(/,/g, '')) > Number(this.txtMab.replace(/,/g, ''))) {
          this.$mySweetDefaultTost('خطا', 'مبلغ وارد شده نمیتواند بیشتر از مبلغ کل سند باشد!', 'warning', 1500)
        } else {
          this.rows.push(JSON.parse(JSON.stringify(savedlist[0])))
        }
      } else {
        this.rows = savedlist
        // this.rows=this.$AddSumRow(this.rows)
      }
    },
    GetAzaInfo(Id, Isfinde, GoRoute) {
      try {
        this.DataAxios_tblaza.Method = 'Post'
        this.DataAxios_tblaza.Action = 'AzaInfo/Index/?id=' + Id
        this.$PostData(this.DataAxios_tblaza)
          .then((data) => {
            if (Isfinde) {
              this.AzaInfoEditData[0] = data
              this.$store.state.OldDataForLog = JSON.stringify(data)
              this.$router.push({
                name: 'azainfo',
                params: { EditData: this.AzaInfoEditData[0], Status: 'Edit' },
              })
            } else {
              switch (GoRoute) {
                case 'AzaPasAndJari':
                  this.AzaPasAndJariRowData[0] = data
                  this.AzaPasAndJariRowData[0].TblAzaId = data.Id
                  this.$session.set('DetailUser', data)
                  this.$router.push({ name: GoRoute, params: { AzaInfo: this.AzaPasAndJariRowData[0] } })
                  break
                case 'AzaTashilats':
                  this.AzaTashilatsRowData[0] = data
                  this.AzaTashilatsRowData[0].TblAzaId = data.Id
                  this.$session.set('DetailUser', data)
                  this.$router.push({ name: GoRoute, params: { AzaInfo: this.AzaTashilatsRowData[0] } })
                  break
                default:
                  break
              }
            }
          })
          .finally(() => {})
      } catch (error) {
        console.log(error)
      }
    },
    SetLabels() {
      try {
        if (this.TblSarfaslTypeId != 0) {
          switch (this.TblSarfaslTypeId) {
            case 1:
              var mah = this.TarixGhest == '' ? this.$store.state.JalaliDate : this.$b_GetMahName(this.TarixGhest.substring(5, 7))
              this.txtDes = ' دریافت قسط ' + mah + ' ' + this.lblMoshaxasat
              break
            case 2:
              this.txtDes = 'برداشت از پس انداز' + this.lblMoshaxasat
              break
            case 6:
              this.txtDes = ' برداشت از سپرده ' + this.lblMoshaxasat
              break
            case 13:
              this.txtDes = ' برداشت از جاري ' + this.lblMoshaxasat
              break
            default:
              break
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    FormNew() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$refs.txtVCode.focus()
      this.DataAxios_Pardakht.ArryfildValue.TarixSanad = this.$store.state.JalaliDate
      //this.LoadItem = true
      this.BackSanad(this.DataSabtDaem[0])
    },
    BtntxtDes() {
      this.LoadSharh = true
    },
    InsertMab(e) {
      if (e.key == 'Insert') {
        this.GetBajeBank()
        this.txtMabTaraf = 0
      }
    },
    InsertMabTarkibiChandGane(e) {
      if (e.key == 'Insert') {
        this.GetBajeBankTarkibi()
        this.txtMabBankTarkibiChandGane = 0
      }
    },
    BackSanad(data) {
      if (data.b_SanadId != 0) {
        this.ShomareBackSanad = data.b_ShomareSanad
      }
    },
    GoToSanad() {
      if (this.ShomareBackSanad != 0 && this.DataSabtDaem[0].b_SanadId != 0) {
        this.DataAxios_GetSanadId.Action = 'SearchSanad/GetSanadId?id=' + this.DataSabtDaem[0].b_SanadId
        this.DataAxios_GetSanadId.ArryfildValue = null
        var temp_rows
        this.$PostData(this.DataAxios_GetSanadId)
          .then((result) => {
            temp_rows = result
          })
          .finally(() => {
            this.ShowDataSanad[0] = temp_rows
            this.$store.state.SanadRizNew.EditData.sanad = this.ShowDataSanad[0]
            this.$router.push({
              name: 'SanadRizNew',
              params: { Status: 'View' },
            })
          })
      }
    },
  },
}
</script>
<style scoped>
#Pardakht #Modal-Info .modal-content {
  width: 90vw !important;
  margin: auto;
}
.bnpFont {
  font-size: 14px !important;
  font-weight: bold !important;
}
.bnp-lblFont {
  font-size: 14px !important;
}
#fullpage {
  display: none;
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100vw !important;
  min-height: 100vh !important;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-color: rgba(255, 255, 255, 0.679);
}
.img-circle.profile_img1 {
  border: 1px solid rgba(226, 131, 7, 0.44);
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  /* margin: 2px; */
  overflow: hidden;
  border: 0px;
  padding: 4px;
}
.profile_pic1 {
  height: 18vh;
  width: 18vh;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  border-radius: 100%;
  background: #fff;
  border: 2px solid #d17906;
}
.profile_pic2 {
  height: 15vh;
  width: 15vh;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  border-radius: 100%;
  background: #fff;
  border: 2px solid #d17906;
}
</style>
<style>
#Pardakht #ModalBanafash .modal-content {
  width: 80vw !important;
  margin: auto;
}
#Pardakht #ModalBanafash .modal-dialog {
  margin-right: 15vw !important;
}
#Pardakht #ModalBanafash .modal-dialog {
  max-width: 90vw !important;
}
#Pardakht #Modal-Info .modal-content {
  width: 80vw !important;
  margin: auto;
}
#Pardakht #Modal-Info .modal-dialog {
  margin-right: 15vw !important;
}
#Pardakht #Modal-Info .modal-dialog {
  max-width: 90vw !important;
}
#Pardakht #Modal-light .modal-content {
  width: 80vw !important;
  margin: auto;
}
#Pardakht #Modal-light .modal-dialog {
  margin-right: 15vw !important;
}
#Pardakht #Modal-light .modal-dialog {
  max-width: 90vw !important;
}
</style>
